import './config/vuetify'



export const DEFAULT_NAV_SORT_VALUE = 500;
export const IS_PRODUCTION = 'production' === process.env.NODE_ENV;
